import dayjs from 'dayjs';

import { ITradeAgreement } from 'quotes/types';

/**
 * Valid through its end date, compared by calendar day as displayed. No end date never expires.
 */
export const isTradeAgreementExpired = (
  agreement?: Pick<ITradeAgreement, 'spaCostEndDate'> | null,
  now: Date = new Date()
): boolean => {
  const endDate = agreement?.spaCostEndDate ? dayjs(agreement.spaCostEndDate) : null;

  return !!endDate?.isValid() && endDate.isBefore(dayjs(now), 'day');
};
